import React from 'react';
import { Form, Pane, Label } from '@leverege/ui-elements';
import { Geocoder } from '@leverege/ui-geo-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class AddressEditor extends React.Component {
  static contextType = Form.Context;
  onChange = evt => {
    const {
      data,
      value
    } = evt;
    const {
      validator
    } = this.context;
    const {
      attr
    } = this.props;
    const positionKey = attr?.blueprint?.attribute?.getTagStartingWith('addressEditorPositionKey:', true);
    validator.onInputChange({
      data,
      value: value.properties?.address
    });
    if (positionKey) {
      validator.onInputChange({
        data: `data/${positionKey}`,
        value: value.position
      });
    }
  };
  render() {
    const {
      attr,
      disabled,
      ...rest
    } = this.props;
    const {
      validator,
      loading
    } = this.context;
    const name = attr?.blueprint?.updatePath;
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colS",
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: attr.displayName
      }), /*#__PURE__*/_jsx(Geocoder, {
        ...rest,
        ...validator.dataProps(name),
        useUserLocation: true,
        name: name,
        eventData: name,
        onChange: this.onChange,
        value: validator.value(name),
        disabled: loading === true || disabled === true
      }), /*#__PURE__*/_jsx(Form.Error, {
        variant: "inputCaptionSmallError",
        name: attr?.blueprint?.updatePath
      })]
    });
  }
}
const type = 'address';
export default {
  editor: AddressEditor,
  type
};